/* COMPONENT - placeholderText 1.0 */
'use strict';

export default function() {
    if (document.querySelector('html').classList.contains('ltie10')) {
        var placeholders = document.querySelectorAll('[placeholder]'),
            i,
            forms = [];
        
        for (i = 0; i < placeholders.length; i += 1) {
            placeholders[i].addEventListener('focus', function () {
                if (this.value === this.getAttribute('placeholder')) {
                    this.value = '';
                }
            });
            
            placeholders[i].addEventListener('blur', function () {
                if (this.value === '' || this.value === this.getAttribute('placeholder')) {
                    this.value = this.getAttribute('placeholder');
                }
            });
            
            if(!placeholders[i].form.placeholderEventAdded) {
                placeholders[i].form.placeholderEventAdded = true;
                forms.push(placeholders[i].form);
            }
            
            placeholders[i].blur();
        }

        forms.forEach(function (form) {
            form.addEventListener('submit', function () {
                var placeholders = form.querySelectorAll('[placeholder]'),
                    i;
                
                for (i = 0; i < placeholders.length; i += 1) {
                    if (placeholders[i].value === placeholders[i].getAttribute('placeholder')) {
                        placeholders[i].value = '';
                    }
                }
            });
        });
    }
}
